import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
  children?: ReactNode;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  onReset,
  resetLabel = "重置筛选",
  children,
}: EmptyStateProps) {
  return (
    <div className="w-full rounded-lg bg-background-900 border border-background-800 px-6 py-14 md:py-20 flex flex-col items-center text-center animate-fade-in">
      <span className="w-16 h-16 rounded-full bg-background-800 flex items-center justify-center mb-5">
        <i className={`${icon} text-3xl text-primary-400`}></i>
      </span>
      <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-100">{title}</h3>
      <p className="text-sm text-foreground-400 mt-3 max-w-md leading-relaxed">{description}</p>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-6 px-5 py-2.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer transition-colors"
        >
          {resetLabel}
        </button>
      )}
      {children}
    </div>
  );
}